import { InputText } from "@bluframe/blublocks"
import {
  FieldLabel,
  FieldLabelAndValue,
  FieldRow,
  FieldValue
} from "components/Fields/styled"

import { ComponentProps } from "."

const ImagesRow = ({
  isEditMode,
  item,
  logoImageIdRef,
  splashImageIdRef
}: Pick<
  ComponentProps,
  "isEditMode" | "item" | "logoImageIdRef" | "splashImageIdRef"
>) => (
  <FieldRow $items={2}>
    {isEditMode ? (
      <>
        <InputText
          defaultValue={item?.logoImageId ?? ""}
          inputId="logoImageId"
          label="Logo Image ID"
          name="logoImageId"
          ref={logoImageIdRef}
          type="number"
        />

        <InputText
          defaultValue={item?.splashImageId ?? ""}
          inputId="splashImageId"
          label="Splash Image ID"
          name="splashImageId"
          ref={splashImageIdRef}
          type="number"
        />
      </>
    ) : (
      <>
        <FieldLabelAndValue>
          <FieldLabel>{"Logo Image ID"}</FieldLabel>

          <FieldValue>{item?.logoImageId}</FieldValue>
        </FieldLabelAndValue>

        <FieldLabelAndValue>
          <FieldLabel>{"Splash Image ID"}</FieldLabel>

          <FieldValue>{item?.splashImageId}</FieldValue>
        </FieldLabelAndValue>
      </>
    )}
  </FieldRow>
)

export default ImagesRow
